import React, { useState } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { api } from '../../../utils/api'

/**
 * DownloadAllAttachments - Downloads all attachments as a zip file
 */
function DownloadAllAttachments({ ticketId, attachments }) {
  const [downloading, setDownloading] = useState(false)
  const [progress, setProgress] = useState('')

  async function downloadAll() {
    const downloadable = attachments.filter(a => a.attachmentId)
    if (!downloadable.length) return

    setDownloading(true)
    setProgress(`0/${downloadable.length}`)

    try {
      const zip = new JSZip()
      const usedNames = new Set()

      for (let i = 0; i < downloadable.length; i++) {
        setProgress(`${i + 1}/${downloadable.length}`)
        try {
          const response = await api.get(`/api/tickets/${ticketId}/attachment/${downloadable[i].attachmentId}`)
          if (response.data) {
            // Convert data URL to binary
            const base64 = response.data.split(',')[1]
            // Deduplicate filenames
            let name = downloadable[i].filename || `attachment_${i + 1}`
            if (usedNames.has(name)) {
              const ext = name.lastIndexOf('.') > 0 ? name.substring(name.lastIndexOf('.')) : ''
              const base = ext ? name.substring(0, name.lastIndexOf('.')) : name
              let n = 2
              while (usedNames.has(`${base}_${n}${ext}`)) n++
              name = `${base}_${n}${ext}`
            }
            usedNames.add(name)
            zip.file(name, base64, { base64: true })
          }
        } catch (err) {
          console.error(`Failed to fetch attachment ${i + 1}:`, err)
        }
      }

      const blob = await zip.generateAsync({ type: 'blob' })
      saveAs(blob, `attachments_${ticketId}.zip`)
    } catch (error) {
      console.error('Failed to create zip:', error)
      alert('Failed to download attachments')
    } finally {
      setDownloading(false)
      setProgress('')
    }
  }

  return (
    <button
      onClick={downloadAll}
      disabled={downloading}
      style={{
        background: 'none',
        border: 'none',
        color: 'var(--primary)',
        cursor: downloading ? 'wait' : 'pointer',
        fontSize: 11,
        fontWeight: 500,
        padding: '2px 6px',
        borderRadius: 4
      }}
      title="Download all attachments as zip"
    >
      {downloading ? `Downloading ${progress}...` : 'Download All'}
    </button>
  )
}

export default DownloadAllAttachments
